/* eslint-disable no-unused-vars */
export const ORIENTATION = {
    VERTICAL: 'vertical',
    HORIZONTAL: 'horizontal',
};
export const INDICATOR_FIXED_DIMENSION_SIZE = '2px';
export var Layout;
(function (Layout) {
    Layout["STRETCH"] = "stretch";
    Layout["INLINE"] = "inline";
    Layout["FIXED"] = "fixed";
})(Layout || (Layout = {}));
//# sourceMappingURL=constants.js.map